import {formatPrice, Variant} from "../../models/product";
import {Component, ComponentChild, h, RenderableProps} from "preact";
import {CountryService, NY_CountryService} from "../../services/country-service";
import App from "../app";
import {i18nService} from "../../services/i18n-service";

interface Props {
    styles: { [key: string]: string }
    variant: Variant
}

export class ProductPrice extends Component<Props, any> {
    render({variant, styles}: RenderableProps<Props>): ComponentChild {
        if (!variant.showPriceLabel()) return null;

        return (
            <div class={styles['price-container']}>
                {variant.sale ?
                    <div className={styles['sale-container']}>
                        <div className={styles["sale-price-container"]}>
                            {(NY_CountryService.showOriginalPrice(App.countryCode) || variant.originalExchangePrice) &&
                                <span className={styles['original-price']}>
                  {formatPrice(variant.originalPrice, variant.currency)}
                </span>
                            }

                            <span
                                className={(NY_CountryService.showOriginalPrice(App.countryCode) || variant.originalExchangePrice) ?
                                    styles['sale-price-with-original-price'] : styles['sale-price']}>
                {formatPrice(variant.currentPrice, variant.currency)}
              </span>
                        </div>

                        {(variant.originalExchangePrice || variant.currentExchangePrice) &&
                            <div className={styles['original-price-container']}>
                                {variant.originalExchangePrice &&
                                    <span className={styles['original-price']}>
                    {formatPrice(variant.originalExchangePrice, variant.exchangeCurrency)}
                  </span>
                                }

                                <span
                                    className={(NY_CountryService.showOriginalPrice(App.countryCode) || variant.originalExchangePrice) ?
                                        styles['sale-price-with-original-price'] : styles['sale-price']}>
                  {formatPrice(variant.currentExchangePrice, variant.exchangeCurrency)}
                </span>
                            </div>
                        }
                    </div> :

                    <div class={styles['current-price-container']}>
                        <span>{formatPrice(variant.currentPrice, variant.currency)}</span>

                        {variant.currentExchangePrice &&
                            <span class={styles['current-exchange-price']}>
                {formatPrice(variant.currentExchangePrice, variant.exchangeCurrency)}
              </span>
                        }
                    </div>
                }
            </div>
        );
    }
}